<div class="not-found-container">
    <div class="illustration-container">
        <!-- Replace with the actual image path from assets if available -->
        <img src="assets/404error.png" alt="404 Under Construction" class="img-404" />
    </div>

    <div class="error-pill">
        <i class="fa fa-exclamation-circle"></i> ERROR 404
    </div>

    <h1 class="main-title">Oops!<br>Page Not Found</h1>

    <p class="description">
        The path you're following seems to be<br>under construction or doesn't exist.
    </p>

    <div class="action-buttons">
        <button class="btn btn-dashboard" (click)="goToDashboard()">
            <i class="fa fa-home"></i> BACK TO DASHBOARD
        </button>
        <a href="javascript:void(0)" (click)="goBack()" class="link-previous">
            Return to previous page
        </a>
    </div>

    <div class="suggested-paths-section">
        <h6 class="section-title">SUGGESTED PATHS</h6>
        
        <div class="paths-grid">
            <div class="path-card" (click)="goToDashboard()">
                <div class="icon-wrapper icon-yellow">
                    <i class="fa fa-wrench"></i>
                </div>
                <div class="path-info">
                    <h5>Site Status</h5>
                    <p>Check current work site updates</p>
                </div>
            </div>

            <div class="path-card" (click)="goToDashboard()">
                <div class="icon-wrapper icon-blue">
                    <i class="fa fa-book"></i>
                </div>
                <div class="path-info">
                    <h5>Safety Manual</h5>
                    <p>Review safety protocols</p>
                </div>
            </div>

            <div class="path-card" (click)="goToDashboard()">
                <div class="icon-wrapper icon-orange">
                    <i class="fa fa-headphones"></i>
                </div>
                <div class="path-info">
                    <h5>Support</h5>
                    <p>Get help from the team</p>
                </div>
            </div>

            <div class="path-card" (click)="goToDashboard()">
                <div class="icon-wrapper icon-grey">
                    <i class="fa fa-flag"></i>
                </div>
                <div class="path-info">
                    <h5>Report</h5>
                    <p>Flag a broken link</p>
                </div>
            </div>
        </div>
    </div>
</div>
